/* eslint-disable */
import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopPreCallForm(props) {
  const {open, close} = props;
  return (
    <>
      <Modal open={open} close={close} type="pop_pre_call_form com_input" popSize="m">
        <h2 className="pop_tit">사전통화 내용 입력</h2>
        <div className="content_container scroll mb_no">
          <table className="com_board_list type_row">
            <colgroup>
              <col width="140" />
              <col width="auto" />
            </colgroup>
            <tbody>
              <tr>
                <th rowSpan={3}>첫 수업시간 변경</th>
                <td>
                  <div className="check">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">유</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">무</label>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <input type="text" className="input" placeholder="사유 입력." />
                </td>
              </tr>
              <tr>
                <td>
                  <div className="com_input_wrap flex_row">
                    <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                    <select name="" id="" className="select ws">
                      <option value="20시">20시</option>
                    </select>
                    <select name="" id="" className="select ws">
                      <option value="20분">20분</option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <th rowSpan={2}>사전통화 진행여부</th>
                <td>
                  <div className="check">
                    <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                    <label htmlFor="rdo03">학생</label>
                    <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                    <label htmlFor="rdo04">학부모+학생</label>
                    <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                    <label htmlFor="rdo04">미진행</label>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <input type="text" className="input" placeholder="사유 입력." />
                </td>
              </tr>
              <tr>
                <th rowSpan={4}>수업장소</th>
                <td>
                  <div className="check">
                    <input type="radio" name="rdo" id="rdo05" className="com_chk circle" />
                    <label htmlFor="rdo05">일치</label>
                    <input type="radio" name="rdo" id="rdo06" className="com_chk circle" />
                    <label htmlFor="rdo06">불일치</label>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <input type="text" className="input" placeholder="사유 입력." />
                </td>
              </tr>
              <tr>
                <td>
                  <div className="com_input_wrap flex_row">
                    <input type="text" className="input wl" placeholder="주소" />
                    <button className="com_btn gray xs">우편번호</button>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <input type="text" className="input" placeholder="상세주소" />
                </td>
              </tr>
              <tr>
                <th rowSpan={2}>입회원 정보</th>
                <td>
                  <div className="check">
                    <input type="radio" name="rdo" id="rdo07" className="com_chk circle" />
                    <label htmlFor="rdo07">일치</label>
                    <input type="radio" name="rdo" id="rdo08" className="com_chk circle" />
                    <label htmlFor="rdo08">불일치</label>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <button className="com_btn gray xs">입회 원서 열기</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="btn_container">
          <button className="com_btn orange s">확인</button>
        </div>
      </Modal>
    </>
  );
}

export default PopPreCallForm;
